// extracted by mini-css-extract-plugin
export default {"root":"HireFormModal_root__NCKuS","placeHolderShimmer":"HireFormModal_placeHolderShimmer__2dy4f"};